import { OversightAnalyzerKind } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const analyzerKindMessages = defineMessages({
  conversationHealth: {
    defaultMessage: 'Conversation health',
    description: 'oversight analyzer kind name',
  },
  documentClassifier: {
    defaultMessage: 'Document classifier',
    description: 'oversight analyzer kind name',
  },
  noop: {
    defaultMessage: 'No-op (test)',
    description: 'oversight analyzer kind name',
  },
})

export function translateAnalyzerKind(intl: IntlShape, kind: OversightAnalyzerKind): string {
  switch (kind) {
    case OversightAnalyzerKind.CONVERSATION_HEALTH:
      return intl.formatMessage(analyzerKindMessages.conversationHealth)
    case OversightAnalyzerKind.DOCUMENT_CLASSIFIER:
      return intl.formatMessage(analyzerKindMessages.documentClassifier)
    case OversightAnalyzerKind.NOOP:
      return intl.formatMessage(analyzerKindMessages.noop)
  }
}
